export default __webpack_public_path__ + "static/media/with-text.a2e67c0b.png";